export default "__VITE_ASSET__cLXzno7o__"